import React from 'react';
import { translate } from '../../../services/translate';
import Toast from 'react-native-toast-message';
import moment from 'moment';
import 'react-calendar/dist/Calendar.css';
import '../../../styles/date-ranger-picker.css';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import CompanyDropdown from '../../../components/CompanyDropdown';
import { crmService } from '../../../services/central-api/crm';
import { useForm } from 'react-hook-form';
import FormSwitch from '../../../components/FormSwitch';
import BasicModal from '../../../components/BasicModal';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
}

interface DownloadForm {
    companyId: number;
    offlineOnly: boolean;
    disabledOnly: boolean;
    withThirdParty: boolean;
    notIncludePanoramicChildren: boolean;
    wrongHttpAddressOnly: boolean;
}

export default function DownloadReportModal({ isModalVisible, setModalVisible }: ModalProps) {
    const defaultEmptyValues: DownloadForm = {
        companyId: 0,
        offlineOnly: false,
        disabledOnly: false,
        withThirdParty: false,
        notIncludePanoramicChildren: false,
        wrongHttpAddressOnly: false
    };

    const form = useForm<DownloadForm>({
        defaultValues: defaultEmptyValues,
        mode: 'onChange'
    });

    async function formSubmit() {
        try {
            const csv = await crmService.downloadCameraReport(form.getValues());
            if (!(csv instanceof Blob)) {
                throw new Error();
            }
            const url = window.URL.createObjectURL(csv);
            const a = document.createElement('a');
            a.href = url;
            a.download = `cameras-${moment(new Date()).format('YYYY-MM-DD')}.csv`;
            a.click();
            window.URL.revokeObjectURL(url);

            form.reset(defaultEmptyValues);

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });

        } catch (error) {
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            width='small'
            title={translate('downloadReport')}
            primaryButton={{
                text: translate('download'),
                onClick: formSubmit,
                disabled: !form.watch('companyId'),
            }}
            cancelButton={{
                onClick: () => form.reset(defaultEmptyValues),
            }}
        >
            <CompanyDropdown
                form={form}
                fieldName='companyId'
                required={true}
                disabled={false}
                zIndex={2}
            />
            <FormSwitch
                label={translate('offlineOnly')}
                form={form}
                fieldName='offlineOnly'
            />
            <FormSwitch
                label={translate('disabledOnly')}
                form={form}
                fieldName='disabledOnly'
            />
            <FormSwitch
                label={translate('withThirdParty')}
                form={form}
                fieldName='withThirdParty'
            />
            <FormSwitch
                label={translate('wrongHttpAddressOnly')}
                form={form}
                fieldName='wrongHttpAddressOnly'
            />
            <FormSwitch
                label={translate('notIncludePanoramicChildren')}
                form={form}
                fieldName='notIncludePanoramicChildren'
            />
        </BasicModal>
    );
}
